// src/layouts/AuthLayout.tsx
// Auth layout — centered glassmorphism card with nav bar. The animated
// background is provided by the parent PublicLayout so it persists across
// navigation between auth pages.
// Ported from Next.js app/(public)/auth/layout.tsx.

import { Link, Outlet } from 'react-router'
import { ArrowLeft } from 'lucide-react'

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Nav */}
      <nav className="flex items-center justify-between px-6 py-5 max-w-5xl mx-auto w-full">
        <Link to="/" className="flex items-center gap-2.5">
          <img
            src="/logo-symbol.png"
            alt="SiteGenius"
            width={32}
            height={32}
            className="rounded-xl"
          />
          <span className="font-bold text-lg tracking-tight text-white">
            SiteGenius
          </span>
        </Link>
        <Link
          to="/"
          className="flex items-center gap-1.5 text-sm text-neutral-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back</span>
        </Link>
      </nav>

      {/* Centered card */}
      <main className="flex flex-1 items-center justify-center px-4 pb-16">
        <div
          className="w-full max-w-[400px] rounded-2xl p-6"
          style={{
            background: 'linear-gradient(135deg, rgba(18, 16, 14, 0.92) 0%, rgba(20, 18, 16, 0.88) 100%)',
            backdropFilter: 'blur(24px) saturate(1.2)',
            WebkitBackdropFilter: 'blur(24px) saturate(1.2)',
            border: '1px solid rgba(255, 255, 255, 0.10)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.06), inset 0 0 0 1px rgba(180, 100, 50, 0.06)',
          }}
        >
          <Outlet />
        </div>
      </main>
    </div>
  )
}
